import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<
  Props,
  'image' | 'thumbnail' | 'thumbnailPlaying' | 'headline'
>({
  name: 'PlaylistVideoCard',
  uniqId: 'f0mm90',
})(
  (
    { spacing, breakpoints, aspectRatio, brandColors, typography },
    props,
    classes
  ) => ({
    card: {
      cursor: 'pointer',
      textAlign: 'left',
      border: 'none',
      margin: 0,
      padding: 0,
      width: typography.pxToRem(200),
      overflow: 'visible',
      background: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(0),

      [breakpoints.up('sm')]: {
        width: typography.pxToRem(287),
      },

      '&:hover, &:focus': {
        [`& .${classes.image}`]: {
          transform: 'scale(1.1)',
        },

        [`& .${classes.thumbnail}`]: {
          color: 'rgba(0, 0, 0, 0.6)',
        },

        [`& .${classes.thumbnailPlaying}`]: {
          color: 'rgba(0, 0, 0, 1)',
        },

        [`& .${classes.headline}`]: {
          color: darkOrLightStyle(props)(
            brandColors.offWhite,
            brandColors.primaryMain
          ),
        },
      },
    },
    headline: {
      width: typography.pxToRem(200),
      WebkitLineClamp: 3,
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      wordBreak: 'break-word',
      textOverflow: 'ellipsis',
      whiteSpace: 'normal',
      textDecoration: 'underline',
      color: darkOrLightStyle(props)(brandColors.white, brandColors.mediumBlue),

      [breakpoints.up('sm')]: {
        width: typography.pxToRem(287),
      },
    },
    thumbnail: {
      position: 'relative',
      borderRadius: typography.pxToRem(16),
      overflow: 'hidden',
      color: 'rgba(0, 0, 0, 0.3)',
      display: 'flex',
    },
    thumbnailPlaying: {
      color: 'rgba(0, 0, 0, 0.6)',
    },
    image: {
      alignSelf: 'flex-start',
      width: '100%',
      aspectRatio: aspectRatio['16/9'],
      transition: 'transform 0.3s ease-in-out',
      objectFit: 'cover',
    },
    videoPosition: {
      color: darkOrLightStyle(props)(
        brandColors.tintsOffWhite40,
        brandColors.tintsNeutral20
      ),
    },
    playerControl: {
      color: 'inherit',
      position: 'absolute',
      bottom: typography.pxToRem(12),
      left: typography.pxToRem(12),

      [breakpoints.up('sm')]: {
        bottom: typography.pxToRem(16),
        left: typography.pxToRem(16),
      },
    },
  })
);

export default useStyles;
